/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './search-bar.component.less.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@ngx-translate/core/src/translate.pipe';
import * as i3 from '@ngx-translate/core/src/translate.service';
import * as i4 from '../../../../app/custom/search-bar/search-bar.component';
import * as i5 from '@angular/router';
const styles_SearchBarComponent:any[] = [i0.styles];
export const RenderType_SearchBarComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SearchBarComponent,data:{}});
export function View_SearchBarComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{searchRef:0}),(_l()(),i1.ɵeld(1,0,(null as any),
      (null as any),7,'div',[['class','box-control']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['\n  '])),(_l()(),i1.ɵeld(3,0,(null as any),(null as any),1,'div',[['class',
      'box-icon']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(4,0,(null as any),(null as any),0,'i',[['class','icon icon-middle icon-search']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(6,0,[[1,0],['searchRef',
          1]],(null as any),1,'input',[['class','search-control'],['type','text']],
          [[8,'placeholder',0]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵpid(131072,i2.TranslatePipe,[i3.TranslateService,i1.ChangeDetectorRef]),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (null as any),(_ck,_v) => {
        const currVal_0:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,6,0,i1.ɵnov(_v,
            7).transform('OTHER.searchHorses')),'');
        _ck(_v,6,0,currVal_0);
      });
}
export function View_SearchBarComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-search-bar',
      ([] as any[]),(null as any),(null as any),(null as any),View_SearchBarComponent_0,
      RenderType_SearchBarComponent)),i1.ɵdid(1,4440064,(null as any),0,i4.SearchBarComponent,
      [i5.Router,i5.ActivatedRoute],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const SearchBarComponentNgFactory:i1.ComponentFactory<i4.SearchBarComponent> = i1.ɵccf('app-search-bar',
    i4.SearchBarComponent,View_SearchBarComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvY3VzdG9tL3NlYXJjaC1iYXIvc2VhcmNoLWJhci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS92c3RzL3dvcmsvMS9zL2Vtci13ZWJhcHAvc3JjL2FwcC9jdXN0b20vc2VhcmNoLWJhci9zZWFyY2gtYmFyLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvY3VzdG9tL3NlYXJjaC1iYXIvc2VhcmNoLWJhci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvY3VzdG9tL3NlYXJjaC1iYXIvc2VhcmNoLWJhci5jb21wb25lbnQudHMuU2VhcmNoQmFyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImJveC1jb250cm9sXCI+XG4gIDxkaXYgY2xhc3M9XCJib3gtaWNvblwiPjxpIGNsYXNzPVwiaWNvbiBpY29uLW1pZGRsZSBpY29uLXNlYXJjaFwiPjwvaT48L2Rpdj5cbiAgPGlucHV0ICNzZWFyY2hSZWYgdHlwZT1cInRleHRcIiBjbGFzcz1cInNlYXJjaC1jb250cm9sXCIgcGxhY2Vob2xkZXI9XCJ7eyAnT1RIRVIuc2VhcmNoSG9yc2VzJyB8IHRyYW5zbGF0ZX19XCI+XG48L2Rpdj5cbiIsIjxhcHAtc2VhcmNoLWJhcj48L2FwcC1zZWFyY2gtYmFyPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozt1RENBQTtNQUFBO01BQUEsNENBQXlCO01BQUEsV0FDdkI7TUFBQTtNQUFzQjtVQUFBO01BQWtELDRDQUN4RTtVQUFBO1VBQUE7YUFBcUQ7TUFBb0QsMENBQ3JHOztRQURpRDtZQUFBO1FBQXJELFdBQXFELFNBQXJEOzs7O29CQ0ZGO01BQUE7bUNBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/$$_gendir/app/custom/search-bar/search-bar.component.ngfactory.ts